import React from 'react';
import Root from 'components/Root';
import {
    HashRouter as Router,
    Route,
    Switch,
    Redirect,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authSelector } from 'redux/auth/selectors';
import publicRoutes from './publicRoutes';
import privateRoutes from './privateRoutes';
import commonRoutes from './commonRoutes';
import NotFound from 'components/layout/NotFound';

const Routes = () => {
    const { isAuthenticated } = useSelector(authSelector);
    const { publicAccess } = useSelector((state) => state.settings);

    const getRoutes = () => {
        return [...publicRoutes(), ...commonRoutes(), ...privateRoutes()];
    };

    return (
        <Root>
            <Router>
                <Switch>
                    <Route exact path="/">
                        <Redirect
                            to={
                                isAuthenticated || publicAccess
                                    ? '/dashboard'
                                    : '/login'
                            }
                        />
                    </Route>
                    {getRoutes().map((route) => route)}
                    <Route component={NotFound} />
                </Switch>
            </Router>
        </Root>
    );
};

export default Routes;
